var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.resolveComponentVariant,{tag:"component",attrs:{"asset":_vm.asset,"canEditWeb3Fields":_vm.canEditWeb3Fields},on:{"update:asset":function($event){_vm.asset=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }